import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getLocationId,
  getSaleType,
  getDeliveryTime,
  getDeliveryAddressString,
  getBufferDeliveryTimeFetchedEstimate,
} from '../selectors';

import { setDeliveryTimeFetchedEstimate } from '../reducers/currentOrder/deliveryTimeFetchedEstimate';
import { setDeliveryTimeFetchedEstimateSyncing } from '../reducers/currentOrder/deliveryTimeFetchedEstimateSyncing';

import { fetchDeliveryEstimate } from './fetchDeliveryEstimate';

import { ASAP_TIME } from '../constants';
import { SALE_TYPE } from '../constants/saleType';

export const syncASAPDeliveryTimeFetchedEstimate = createAsyncThunk(
  '$syncASAPDeliveryTimeFetchedEstimate',
  async (_data, { dispatch, getState, rejectWithValue }) => {
    const initialState = getState() as EntireFrontendState;

    const locationId = getLocationId(initialState);
    const saleType = getSaleType(initialState);
    const deliveryTime = getDeliveryTime(initialState);
    const deliveryAddress = getDeliveryAddressString(initialState);

    try {
      if (
        //* Note: This never gets called for delivery of catering because it never
        //* has the option for ASAP, the user has to always schedule a time &
        //* date.

        saleType === SALE_TYPE.DELIVERY &&
        deliveryAddress &&
        locationId &&
        deliveryTime === ASAP_TIME
      ) {
        dispatch(setDeliveryTimeFetchedEstimateSyncing(true));
        await dispatch(
          fetchDeliveryEstimate({
            deliveryAddress,
            desiredDeliveryTime: deliveryTime,
            locationId: locationId,
          }),
        ).unwrap();

        const bufferDeliveryTimeFetchedEstimate =
          getBufferDeliveryTimeFetchedEstimate(
            getState() as EntireFrontendState,
          );

        dispatch(
          setDeliveryTimeFetchedEstimate(bufferDeliveryTimeFetchedEstimate),
        );
        dispatch(setDeliveryTimeFetchedEstimateSyncing(false));
      }
    } catch (e) {
      console.warn('Sync ASAP estimate delivery time failed', { e });
      return rejectWithValue(e);
    }
  },
);
